module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/order-or-lot-allocation-components/order-or-lot-allocation-components.component.css
// module id = ./src/app/order-or-lot-allocation-components/order-or-lot-allocation-components.component.css
// module chunks = main